import React, { memo, ReactElement } from "react";

function IrctcIcon(props: { className?: string; fillColor?: string }): ReactElement {
    return (
        <svg width="20" height="20" fill="none" className={props.className}>
            <path
                fill={props.fillColor || "#02060C"}
                fillOpacity=".92"
                d="M13.32 2H6.68a3.04 3.04 0 0 0-3.04 3.04v7.63a3.04 3.04 0 0 0 3.04 3.04h6.64a3.04 3.04 0 0 0 3.04-3.04V5.04A3.04 3.04 0 0 0 13.32 2Zm-7.2 11.52a.89.89 0 1 1 0-1.77.89.89 0 0 1 0 1.77Zm3.33-5.38c0 .42-.34.76-.76.76H5.72a.75.75 0 0 1-.75-.76V6.26c0-.41.33-.74.74-.74h3c.4 0 .74.33.74.74v1.88Zm-.34-4.6a.89.89 0 1 1 1.78 0 .89.89 0 0 1-1.78 0Zm4.76 9.98a.89.89 0 1 1 0-1.77.89.89 0 0 1 0 1.77Zm1.15-5.38c0 .42-.33.76-.75.76H11.3a.75.75 0 0 1-.75-.76V6.26c0-.41.33-.74.74-.74h3c.4 0 .73.33.73.74v1.88Zm-1.97 8.64H7.2V18h5.84v-1.22Z"
            />
        </svg>
    );
}

export default memo(IrctcIcon);
